module.exports = __webpack_public_path__ + "img/balance_sheet_manual_1.2d3b17d1.png";